import { useStore } from '@nanostores/react'
import { cx } from 'class-variance-authority'

import { Switch } from '~/elements/Switch.tsx'
import { useBillingCatalogQuery } from '~/features/billing/hooks/useBillingHooks'
import { $currentInterval } from '~/features/billing/stores/plans.ts'
import { yearlyFreeMonths } from '~/features/billing/utils'

export function SelectPeriod({ className }: { className?: string }) {
  const interval = useStore($currentInterval)
  const { data: catalog } = useBillingCatalogQuery()
  const freeMonths = Math.max(0, ...(catalog?.plans ?? []).map((plan) => yearlyFreeMonths(plan)))

  return (
    <div className={cx('flex items-center justify-center gap-4', className)}>
      <p className="typography-base font-medium text-content2">Monthly</p>
      <Switch
        aria-label="Bill yearly"
        checked={interval === 'year'}
        onCheckedChange={(checked) => $currentInterval.set(checked ? 'year' : 'month')}
      />
      <p className="typography-base font-medium text-content2">Yearly</p>
      {freeMonths > 0 && (
        <span className="rounded-full bg-gradient-to-bl from-badge-blue/10 to-badge-blue/30 px-3 py-0.5 font-mono text-sm text-badge-blue">
          {freeMonths} months free
        </span>
      )}
    </div>
  )
}
